import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component — sets meta title, description, canonical, OG, Twitter, JSON-LD.
 * Usage: <SEO title="..." description="..." image="..." type="article" schema={{...}} />
 */
const DEFAULTS = {
  siteName: 'Saans Ayurved',
  title: 'Saans Ayurved — Authentic classical Ayurveda, made personal',
  description: 'Free Prakriti Assessment, online consultations with qualified Ayurvedic doctors, and classical formulations. Rooted in tradition.',
  image: 'https://images.unsplash.com/photo-1503891617560-5b8c2e28cbf6?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
};

const SEO = ({ title, description, image, type = 'website', canonical, schema, noindex }) => {
  // Only append " — Saans Ayurved" if the title doesn't already contain the brand,
  // so product/page titles that already end with "| Saans Ayurved" don't double-brand.
  const t = !title
    ? DEFAULTS.title
    : (title.toLowerCase().includes('saans ayurved') ? title : `${title} — Saans Ayurved`);
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {url && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      {url && <meta property="og:url" content={url} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'MedicalOrganization',
  name: 'Saans Ayurved',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://sansayurved.com',
  medicalSpecialty: 'Ayurveda',
  description: 'Authentic classical Ayurvedic consultations, personalized care, and classical formulations.',
};

export default SEO;
